export default "__VITE_ASSET__BQ3u4EQH__"